export default __webpack_public_path__ + "static/SUPPORTS FOR LANGUAGE LEARNING 1_v2-915f5fad68f5ace48e007d077bde312e.png";